import { render, staticRenderFns } from "./StoresView.vue?vue&type=template&id=2c7d0999&"
import script from "./StoresView.vue?vue&type=script&lang=js&"
export * from "./StoresView.vue?vue&type=script&lang=js&"
import style0 from "./StoresView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports